import { Ctx, Game } from 'boardgame.io';
import { MCTSBot } from 'boardgame.io/ai';
import { TurnOrder } from 'boardgame.io/core';
import { BOT_EASY_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE, BOT_EASY_MODE_QUIZ_CARD_PROBABILITY_PERCENTAGE, BOT_HARD_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE } from 'Constants/BotData';
import { INITIAL_CLEAN_ENERGY, TOTAL_CLEAN_ENERGY } from 'Constants/GameData';
import { cardData } from 'Data/Cards';
import { GameHelper } from 'Helpers/GameHelper';
import { Card, CardObjectType, CardType } from 'Models/Card';
import { DeckObjectType } from 'Models/Deck';
import { Options, OptionsObjectType } from 'Models/Questionnaires';

export type PlayedCardInfo = {
    Card: CardObjectType;
    Index: number;
};

export type GameState = {
    deck: DeckObjectType;
    bufferDeck: DeckObjectType;
    computerCards: CardObjectType[]; // 1
    humanCards: CardObjectType[]; // 0
    computerCleanEnergy: number;
    humanCleanEnergy: number;
    humanPointLog?: number[];
    computerPointLog?: number[];
    computerLastPlayedCard?: PlayedCardInfo;
    humanLastPlayedCard?: PlayedCardInfo;
};

const drawCard = (G: GameState, ctx: Ctx, indexOfPlayedCard: number) => {
    const drawnCard: CardObjectType = G.deck.Cards[0];
    G.deck.Cards = G.deck.Cards.slice(1, G.deck.Cards.length);
    if (ctx.currentPlayer === '0') G.humanCards[indexOfPlayedCard] = drawnCard;
    else G.computerCards[indexOfPlayedCard] = drawnCard;
};

const playCard = (G: GameState, ctx: Ctx, indexOfPlayedCard: number, answers?: number[]) => {
    let playedCard: CardObjectType;
    const playerInfo = GameHelper.getPlayerInfo();
    const quizRand = Math.floor(Math.random() * 10);
    if((quizRand <= (BOT_EASY_MODE_QUIZ_CARD_PROBABILITY_PERCENTAGE/10)) && ctx.currentPlayer === '1' && ((playerInfo.age && playerInfo.age < 18) || (playerInfo.eighteenplus && playerInfo.eighteenplus.toLowerCase() === 'no')) && G.computerCards.filter(x => x.Type === CardType.Energy).length > 0) {
        const temp = G.computerCards.filter(x => x.Type === CardType.Energy).reduce(function (prev, current) {
            return (prev.CardValue > current.CardValue) ? prev : current
        });
        indexOfPlayedCard = G.computerCards.indexOf(temp);
    }
    if (ctx.currentPlayer === '0') {
        playedCard = G.humanCards[indexOfPlayedCard];
        if (!G.humanPointLog || G.humanPointLog.length === 0) {
            G.humanPointLog = [];
        }
        G.humanLastPlayedCard = {
            Card: playedCard,
            Index: indexOfPlayedCard,
        };
        // G.humanCards = G.humanCards.filter((_: CardObjectType, idx: number) => idx !== indexOfPlayedCard);
    } else {
        if (!G.computerPointLog || G.computerPointLog.length === 0) {
            G.computerPointLog = [];
        }
        playedCard = G.computerCards[indexOfPlayedCard];
        G.computerLastPlayedCard = {
            Card: playedCard,
            Index: indexOfPlayedCard,
        };
        // G.computerCards = G.computerCards.filter((_: CardObjectType, idx: number) => idx !== indexOfPlayedCard);
    }
    if (playedCard?.useOnSelf) {
        if (playedCard.Type === CardType.Energy) {
            if (ctx.currentPlayer === '0') {
                const correctAnswers: number[] = [];
                playedCard.Questionnaire?.Options.forEach((opt: OptionsObjectType, idx: number) => (opt.IsAnswer ? correctAnswers.push(idx) : null));
                let answerNotFound = false;
                if (correctAnswers.length === answers?.length) {
                    for (let index = 0; index < correctAnswers.length; index++) {
                        if (!answers.includes(correctAnswers[index])) {
                            answerNotFound = true;
                            break;
                        }
                    }
                    if (answerNotFound === false) {
                        G.humanPointLog?.push(playedCard.CardValue);
                        if (playedCard.CardValue + G.humanCleanEnergy > TOTAL_CLEAN_ENERGY) {
                            G.humanCleanEnergy = TOTAL_CLEAN_ENERGY;
                        } else {
                            G.humanCleanEnergy += playedCard.CardValue;
                        }
                    }
                } else {
                    answerNotFound = true;
                }
                if (answerNotFound === true) {
                    G.humanPointLog?.push(-playedCard.CardValue);
                    if (G.humanCleanEnergy - playedCard.CardValue < 0) {
                        G.humanCleanEnergy = 0;
                    } else {
                        G.humanCleanEnergy -= playedCard.CardValue;
                    }
                }
            } else {
                const rand = Math.floor(Math.random() * 10);
                if (rand >= ((((playerInfo.age && playerInfo.age < 18) || (playerInfo.eighteenplus && playerInfo.eighteenplus.toLowerCase() === 'no')) ? BOT_EASY_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE : BOT_HARD_MODE_CORRECT_QUIZ_PROBABILITY_PERCENTAGE) / 10)) {
                    G.computerPointLog?.push(-playedCard.CardValue);
                    if (G.computerCleanEnergy - playedCard.CardValue < 0) {
                        G.computerCleanEnergy = 0;
                    } else {
                        G.computerCleanEnergy -= playedCard.CardValue;
                    }
                } else {
                    G.computerPointLog?.push(playedCard.CardValue);
                    if (playedCard.CardValue + G.computerCleanEnergy > TOTAL_CLEAN_ENERGY) {
                        G.computerCleanEnergy = TOTAL_CLEAN_ENERGY;
                    } else {
                        G.computerCleanEnergy += playedCard.CardValue;
                    }
                }
            }
        } else {
            if (ctx.currentPlayer === '0') {
                G.humanPointLog?.push(playedCard.CardValue);
                if (playedCard.CardValue + G.humanCleanEnergy > TOTAL_CLEAN_ENERGY) {
                    G.humanCleanEnergy = TOTAL_CLEAN_ENERGY;
                } else {
                    G.humanCleanEnergy += playedCard.CardValue;
                }
                // G.humanCleanEnergy += 1200;
            } else {
                G.computerPointLog?.push(playedCard.CardValue);
                if (playedCard.CardValue + G.computerCleanEnergy > TOTAL_CLEAN_ENERGY) {
                    G.computerCleanEnergy = TOTAL_CLEAN_ENERGY;
                } else {
                    G.computerCleanEnergy += playedCard.CardValue;
                }
            }
        }
    } else {
        if (ctx.currentPlayer === '0') {
            G.computerPointLog?.push(-playedCard.CardValue);
            G.computerCleanEnergy -= playedCard.CardValue;
            G.computerCleanEnergy = G.computerCleanEnergy < 0 ? 0 : G.computerCleanEnergy;
        } else {
            G.humanPointLog?.push(-playedCard.CardValue);
            G.humanCleanEnergy -= playedCard.CardValue;
            G.humanCleanEnergy = G.humanCleanEnergy < 0 ? 0 : G.humanCleanEnergy;
        }
    }

    G.bufferDeck.Cards.push(playedCard);
    drawCard(G, ctx, indexOfPlayedCard);
};

export const PGP: Game<GameState> = {
    name: 'PowerGridProtector',
    setup: (ctx: Ctx): GameState => {
        const gameData = GameHelper.getGameData();
        if (gameData) {
            return { bufferDeck: gameData.bufferDeck, deck: gameData.deck, computerCleanEnergy: gameData.computerCleanEnergy, humanCleanEnergy: gameData.humanCleanEnergy, humanCards: gameData.humanCards, computerCards: gameData.computerCards };
        } else {
            let cards: CardObjectType[] = cardData.map((d: Card): CardObjectType => {
            // const card =
                if (d.Type !== CardType.Energy) return { ...d };
                else return { ...d, Questionnaire: { ...d.Questionnaire!, Options: [...d.Questionnaire?.Options!.map((opt: Options): OptionsObjectType => ({ ...opt }))!] } };
            });

            // shuffle deck 3 times
            cards = GameHelper.Shuffle(3, cards);

            const deckObj: DeckObjectType = { Cards: cards, DeckId: '0' };

            // initialize buffer deck
            const bufferDeckObj: DeckObjectType = { Cards: [], DeckId: '1' };
            return { bufferDeck: bufferDeckObj, deck: deckObj, computerCleanEnergy: INITIAL_CLEAN_ENERGY, humanCleanEnergy: INITIAL_CLEAN_ENERGY, humanCards: [], computerCards: [] };
        }
        // initialize game

        // initialize main deck
        
    },
    moves: { playCard },
    turn: {
        moveLimit: 1,
        // game starts with human first
        order: TurnOrder.CUSTOM(['0', '1']),
    },
    endIf: (G: GameState, ctx: Ctx) => {
        // if (GameHelper.calculateCurrentCleanEnergyPercentage(G.computerCleanEnergy) >= 100 || GameHelper.calculateCurrentCleanEnergyPercentage(G.humanCleanEnergy) >= 100) {
        //     console.log(`Winner is ${ctx.currentPlayer === '0' ? 'Human' : 'Computer'}`);
        //     return { winner: ctx.currentPlayer };
        // }
        if (G.computerCleanEnergy >= TOTAL_CLEAN_ENERGY || G.humanCleanEnergy >= TOTAL_CLEAN_ENERGY) {
            console.log(`Winner is ${ctx.currentPlayer === '0' ? 'Human' : 'Computer'}`);
            return { winner: ctx.currentPlayer };
        }
    },

    phases: {
        cardDistribution: {
            start: true, // start game with this phase
            onBegin: (G: GameState, ctx: Ctx) => {
                const gameData = GameHelper.getGameData();
                if (!gameData) {
                    // Distribute cards to players
                    let distributes = 5;
                    const tempCards = G.deck.Cards.filter((x) => x.Type !== CardType.Renewable && x.Type !== CardType.FossilFuel);
                    while (distributes--) {
                        const card1: CardObjectType = tempCards.pop()!;
                        G.humanCards.push(card1);
                        const card2: CardObjectType = tempCards.pop()!;
                        G.computerCards.push(card2);
                        G.deck.Cards = G.deck.Cards.filter((x) => x !== card2 && x !== card1);
                    }
                }                
            },
            // end when both players have 5 cards
            // endIf: (G: GameState, ctx: Ctx) => G.computerCards.length === 5 && G.humanCards.length === 5,
            // start 'gameStart' phase after this phase ends
            next: 'gameStart',
        },
        gameStart: {
            endIf: (G: GameState, ctx: Ctx) => G.deck.Cards.length === 0,
            next: 'swapDeck',
            moves: { playCard },
        },
        swapDeck: {
            onBegin: (G: GameState, ctx: Ctx) => {
                G.deck.Cards = GameHelper.Shuffle(3, G.bufferDeck.Cards);
                G.bufferDeck.Cards = [];
            },
            endIf: (G: GameState, ctx: Ctx) => G.deck.Cards.length > 0,
            next: 'gameStart',
        },
    },
    ai: {
        enumerate: (G: GameState, ctx: Ctx) => {
            let moves: { move: string; args: number[] }[] = [];
            if (ctx.phase === 'gameStart') {
                for (let i = 0; i < G.computerCards.length; i++) {
                    moves.push({ move: 'playCard', args: [i] });
                }
            }
            return moves;
        },
    },
};

export const bot = new MCTSBot({ game: PGP, enumerate: PGP.ai, playoutDepth: 1, iterations: 1 });
